export default "__VITE_ASSET__D1Hv3efh__"